import React from 'react'

export default function Uniqchair() {
  return (
    <section className='my-row bg-violt2'>
         <div className="right">
            <img src='/image/shape3.png' alt='' className='shap3' />
                    <img src="/image/ch14.png" alt="" />
                          </div>
    <div className="left">
       
        <h2>New Furniture Collection
    Trends in 2020</h2>
        <p className="smal colr1">All frames constructed with hardwood solids and laminates</p>
    <p className="smal colr2">Reinforced with double wood dowels, glue, screw - nails corner 
blocks and machine nails</p>
    <p className="smal colr3">Arms, backs and seats are structurally reinforced</p>

<div className="my-row all-r">
        <button className="btn1">Shope Now</button>
<div className='my-col'> <p className="p1" style={{color:'#151875'}}>B&B Italian Sofa </p>
<p style={{color:'#151875'}}>$32.00</p>
</div>
        </div>
    </div>
   
    
    
        </section>
  )
}
